import { Payment } from '../../store/Payment';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getPayment = (id: string) => {
  return apiService.callExternalApi<Payment>({
    url: `${API_SERVER_URL}/payments/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getPaymentsByAssetId = (assetId: string) => {
  return apiService.callExternalApi<Payment[]>({
    url: `${API_SERVER_URL}/payments/asset/${assetId}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listPayments = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'date', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<Payment>>({
    url: buildAdvancedQueryURL(mergedFilters, 'payments'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const patchPayment = (payment: Payment) => {
  return apiService.callExternalApi<Payment>({
    url: `${API_SERVER_URL}/payments/${payment.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(payment)
  });
};

export const createPayment = (payment: Payment) => {
  return apiService.callExternalApi<Payment>({
    url: `${API_SERVER_URL}/payments`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(payment)
  });
};

export const deletePayment = (id: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/payments/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
